import { Component, forwardRef } from '@angular/core';
import { InspectionDetailDto } from '@artemis-software/wr-api';
import { AbstractFormControl } from '../abstract-form-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'wr-norm-type-select',
  templateUrl: './norm-type-select.component.html',
  styleUrls: ['./norm-type-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NormTypeSelectComponent),
      multi: true,
    },
  ],
})
export class NormTypeSelectComponent extends AbstractFormControl<InspectionDetailDto.NormTypeEnum> {
  readonly NormTypes = InspectionDetailDto.NormTypeEnum;
}
